import type { CouponInquiryParam, PersonalLink, ReceiptParam, ReceiptType, ZarinLink } from '@/types';
import api from './useApi';
import {
  couponInquiry as couponInquiryUrl,
  getPersonalLink as getPersonalLinkUrl,
  getProductLink as getZarinLinkUrl,
  receipt as receiptUrl,
  fraudReports,
} from '@/api/service/paths';
import type { FraudReportParam, IFraudReportResponse } from '@/types/api';

const getZarinPersonalLink = (params: string): Promise<{ data: any }> => {
  return api.get<{ data: PersonalLink }>(getPersonalLinkUrl(params));
};

const getZarinProductLink = (params: string): Promise<{ data: any }> => {
  return api.get<{ data: ZarinLink }>(getZarinLinkUrl(params));
};

const sendZarinPersonalLink = (params: string, data: unknown): Promise<{ data: any }> => {
  return api.post(getPersonalLinkUrl(params), data);
};

const sendZarinLink = (params: string, data: unknown): Promise<{ data: any }> => {
  return api.post(getZarinLinkUrl(params), data);
};

const couponInquiry = (data: CouponInquiryParam): Promise<unknown> => {
  return api.post(couponInquiryUrl(), data);
};

const getReceipt = (data: ReceiptParam): Promise<{ data: any }> => {
  return api.post<{ data: ReceiptType }>(receiptUrl(), data);
};

const sendReportProblem = async (data: FraudReportParam): Promise<IFraudReportResponse> => {
  const response = await api.post<IFraudReportResponse>(fraudReports(data.linkType, data.zarin_id), data);
  return response as unknown as IFraudReportResponse;
};

export { getZarinPersonalLink, sendZarinPersonalLink, getZarinProductLink, sendZarinLink, couponInquiry, getReceipt, sendReportProblem };
